const config = {
  apiGateway: {
    REGION: 'us-west-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://f8cdfmyf7e.execute-api.us-west-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://078cd637db.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://5ub4e928t8.execute-api.us-west-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.5',
    HOSTNAME: 'https://locations.staging.valeglobal.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.valeglobal.forwoodsafety.com',
    WEBSOCKET: 'wss://fjbp8skumh.execute-api.us-west-2.amazonaws.com/staging'
  },
};

export default config;